import React, { useState, useRef, useEffect } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { messagingStatusOptions } from '../../utils/messagingStatusParse';
import styles from './style.module.css';

const FIELD_HELP =
  'Filtra os clientes pelo último resultado de WhatsApp. Se vários status forem marcados, a regra inclui quem se encaixa em qualquer um deles.';

const HelpTooltip = ({ text }) => (
  <span
    className={styles.helpWrap}
    tabIndex={0}
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
    }}
  >
    <AiOutlineInfoCircle className={styles.helpIcon} aria-label={text} />
    <span role="tooltip" className={styles.tooltip}>{text}</span>
  </span>
);

const MessagingStatusSelector = ({
  selectedStatus = [],
  handleStatusChange = () => { },
  label = 'Status mensageria',
  excludeStatuses = [],
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleCheckboxChange = (value, e) => {
    e.stopPropagation();
    if (!handleStatusChange) return;

    const next = selectedStatus.includes(value)
      ? selectedStatus.filter((status) => status !== value)
      : [...selectedStatus, value];

    handleStatusChange(next);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const visibleOptions = messagingStatusOptions.filter(
    (option) => !excludeStatuses.includes(option.value)
  );

  const getSelectedText = () => {
    if (!selectedStatus?.length) return 'Selecione um status';
    if (selectedStatus.length === 1) {
      const selected = visibleOptions.find((opt) => opt.value === selectedStatus[0])
        || messagingStatusOptions.find((opt) => opt.value === selectedStatus[0]);
      return selected ? selected.label : '1 status selecionado';
    }
    return `${selectedStatus.length} status selecionados`;
  };

  return (
    <div className={styles.selectorContainer} ref={wrapperRef}>
      {label && (
        <label className={styles.fieldLabel}>
          <span>{label}</span>
          <HelpTooltip text={FIELD_HELP} />
        </label>
      )}
      <div className={isOpen ? `${styles.selectWrapper} ${styles.active}` : styles.selectWrapper}>
        <div className={styles.selectedDisplay} onClick={toggleDropdown}>
          <span>{getSelectedText()}</span>
          <span className={styles.arrow}>{isOpen ? '▲' : '▼'}</span>
        </div>
        <div className={styles.checkboxList}>
          {visibleOptions.map((option) => (
            <label
              key={option.value}
              className={styles.checkboxItem}
              onClick={(e) => e.stopPropagation()}
            >
              <input
                type="checkbox"
                checked={selectedStatus?.includes(option.value)}
                onChange={(e) => handleCheckboxChange(option.value, e)}
              />
              <span className={styles.optionText}>{option.label}</span>
              {option.description && <HelpTooltip text={option.description} />}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MessagingStatusSelector;